import React, {useState} from "react"
import {Link} from "react-router-dom";
import DoneIcon from '../../assets/icons/done.svg';
import CancelIcon from '../../assets/icons/cancel.svg';
import RefundedIcon from '../../assets/icons/refunded.svg';
import {PopupboxManager, PopupboxContainer} from 'react-popupbox';
import CategoryApi from "../../services/categories";

function CategoryTables(props){
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const categoryApi = new CategoryApi(props.token);
    const popupboxConfig = {
        titleBar: {
            enable: true,
            text: 'Please confirm'
        },
        overlayClose:true,
        fadeIn: true,
        fadeInSpeed: 500
    }

    function deleteSingleCategory(id){
        categoryApi.delete(id).then((response) => {
            setData(response.data);
        })
        .catch((err) => {
            console.log(err.message);
            const errorMessage = err.response?.data?.message || err.message;
            setError(errorMessage)
        });
        PopupboxManager.close()
    }

    function openPop(id){
        const content = (
            <div>
                <h4>are you sure to delete Category id : {id} ? </h4>
                <row>
                    <button onClick={() => deleteSingleCategory(id)} className="btn btn-danger warning-btn"> Delete </button>
                    <button onClick={PopupboxManager.close}  className="btn btn-warning warning-btn"> Cancel</button>
                </row>
            </div>
        )
        PopupboxManager.open({ content:content, config: popupboxConfig})
    }
    return(
        <div>
            <PopupboxContainer/>
            {error ? <div className="alert alert-danger" role="alert">
                {error}
            </div> : null}
            {data ? <div className="alert alert-success" role="alert">
                Category with ID {data.data.category.id} has been deleted
            </div> : null}
            <table>
                <tbody>
                    <tr>
                        <th>ID</th>
                        <th>NAME</th>
                        <th>ACTIONS</th>
                    </tr>
                    {props.category.length !== 0 && props.category.map((category, index) => (
                        <tr key={index}>
                            <td><span>{category.id}</span></td>
                            <td><span>{category.name}</span></td>
                            <td><span><Link to="/singlecategory" state={{ id: category.id }}><i
                                className="bi bi-pen">edit</i></Link><br />
                                <i onClick={() => openPop(category.id)} className="bi bi-trash">delete</i>
                            </span></td>
                        </tr>
                    ))
                    }
                </tbody>
            </table>
        </div>
    )

}

export default CategoryTables